var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-button"},[_c('vs-button',{staticClass:"pl-12 pr-12 btn-hanei",attrs:{"color":"primary","type":"filled"},on:{"click":_vm.clickSave}},[_vm._v("保存")]),_c('vs-button',{staticClass:"btn-positive",attrs:{"color":"positive","text-color":"#7367F0","type":"filled"},on:{"click":_vm.clickCancel}},[_vm._v("キャンセル")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }